/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import * as auth from '../redux/AuthRedux'
import { login } from '../redux/AuthCRUD'
import { toAbsoluteUrl } from '../../../../_template/helpers'
import { useIntl } from 'react-intl'
import { ReCaptchaButton } from '../../../../_template/layout/core/ReCaptchaButton'

const loginSchema = Yup.object().shape({
  merchantId: Yup.string()
    .matches(RegExp('^[0-9]*$'), 'Üye İşyeri Id rakam olmalı')
    .min(1, 'Minimum 1 symbols')
    .max(10, 'Maximum 10 symbols')
    .required('MerchantId is required'),
  username: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Username is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  merchantId: "",
  username: '',
  password: '',
}

export function Login() {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      login(parseInt(values.merchantId), values.username, values.password)
        .then(({ data }) => {
          setLoading(false)
          if (data.status) {
            dispatch(auth.actions.login(data.data))
          } else {
            setSubmitting(false)
            setStatus(data.message)
          }
        })
        .catch(() => {
          setLoading(false)
          setSubmitting(false)
          setStatus('The login detail is incorrect')
        })
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>PGPara Ödeme Sistemi</h1>
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{intl.formatMessage({ id: formik.status })}</div>
        </div>
      ) : (<></>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Üye İşyeri No</label>
        <input
          placeholder='Üye İşyeri No'
          {...formik.getFieldProps('merchantId')}
          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
          className={clsx(
            'form-control form-control-lg',
            { 'is-invalid': formik.touched.merchantId && formik.errors.merchantId },
            {
              'is-valid': formik.touched.merchantId && !formik.errors.merchantId,
            }
          )}
          type='text'
          name='merchantId'
          autoComplete='off'
        />
        {formik.touched.merchantId && formik.errors.merchantId && (
          <div className='fv-plugins-message-container invalid-feedback'>
            <span role='alert'>{formik.errors.merchantId}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'AUTH.INPUT.USERNAME' })}</label>
        <input
          placeholder={intl.formatMessage({ id: 'AUTH.INPUT.USERNAME' })}
          {...formik.getFieldProps('username')}
          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
          className={clsx(
            'form-control form-control-lg',
            { 'is-invalid': formik.touched.username && formik.errors.username },
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container invalid-feedback'>
            <span role='alert'>{formik.errors.username}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>{intl.formatMessage({ id: 'AUTH.INPUT.PASSWORD' })}</label>
            {/* end::Label */}
            {/* begin::Link */}
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
            >
              {intl.formatMessage({ id: 'AUTH.FORGOT.TITLE' })}
            </Link>
            {/* end::Link */}
          </div>
        </div>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
          className={clsx(
            'form-control form-control-lg',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container invalid-feedback'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <ReCaptchaButton
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
          loading={loading}
          spanClassName='indicator-label'
          text='Giriş Yap'
          actionName='LOGIN'
        />
      </div>
      {/* end::Action */}
    </form>
  )
}
